type DebouncedFn = ((args: string) => void) & { flush: () => void };

export const debounce = (callbackFunction: (params: string) => void, wait: number): DebouncedFn => {
  let timeout: any = null;
  let lastArgs = '';

  const debounced = (args: string) => {
    lastArgs = args;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      callbackFunction(args);
    }, wait);
  };

  debounced.flush = () => {
    if (timeout) clearTimeout(timeout);
    timeout = null;
    callbackFunction(lastArgs);
  };

  return debounced;
};
